import * as Icons from "lucide-react";
import { HOME } from "@/constants/testIds";
import { SectionLink } from "@/components/SectionLink";

export const SectionCard = ({ section, index }) => {
  const Icon = Icons[section.icon] || Icons.PawPrint;
  return (
    <SectionLink
      url={section.url}
      data-testid={HOME.sectionCard(section.id)}
      className="group fade-up block bg-white border border-[#F0EBE1] rounded-[1.75rem] overflow-hidden hover:-translate-y-1.5 hover:shadow-xl transition-[transform,box-shadow] duration-300"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={section.image} alt={section.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute top-4 left-4 w-11 h-11 rounded-full grid place-items-center text-white shadow" style={{ background: section.accent }}>
          <Icon size={20} />
        </span>
      </div>
      <div className="p-6">
        <h3 className="font-heading text-2xl font-bold tracking-tight">{section.title}</h3>
        <p className="mt-1 text-sm text-stone-500">{section.tagline}</p>
        <span
          data-testid={HOME.sectionLaunch(section.id)}
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold"
          style={{ color: section.accent }}
        >
          {section.cta || `Visit ${section.title}`}
          <Icons.ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </SectionLink>
  );
};
